// extracted by mini-css-extract-plugin
module.exports = {"Stat_label":"Stat_Stat_label_1n10x","Stat_value":"Stat_Stat_value_FWyTN","Stat_multiline":"Stat_Stat_multiline__udNt"};